function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/* Animated top-level menu underline */

// Calculate and set the underline to new position
const moveUnderline = (
  openDetails = null,
  mainMenu = null,
  paddingLeft = 0,
  paddingRight = 0
) => {
  const elements = getMenuElements();
  const menuDetailsElement =
    openDetails === null ? elements.menuDetailsElement : openDetails;
  const menuElement = mainMenu === null ? elements.menuElement : mainMenu;
  const rect = menuDetailsElement && menuDetailsElement.getBoundingClientRect();
  const rectX = !rect || rect.x === 0 ? 12 : rect.x;

  const styles = getComputedStyle(menuDetailsElement.querySelector("summary"));
  paddingLeft = styles.paddingLeft === 0 ? 16 : parseFloat(styles.paddingLeft);
  paddingRight =
    styles.paddingRight === 0 ? 10 : parseFloat(styles.paddingRight);

  const width =
    !menuDetailsElement || menuDetailsElement.offsetWidth === 0
      ? 71
      : menuDetailsElement.offsetWidth;
  const underlineWidth =
    (width - paddingLeft - paddingRight) / window.innerWidth;

  menuElement.style.setProperty("--underline-scale-x", underlineWidth);
  menuElement.style.setProperty(
    "--underline-position-x",
    `${rectX + paddingLeft}px`
  );
};

// Return mobile menu if in mobile view, otherwise return desktop menu
function getMenuElements() {
  const menuElement = document.querySelector("#MobileMainMenu");
  const menuDetailsElement = menuElement.querySelector("details[open]");

  return { menuElement, menuDetailsElement };
}

// Run on initial page load to get initial position, add listener for window resize
moveUnderline();

window.addEventListener("resize", (event) => {
  moveUnderline();
});

// Open first top-level menu item on mouseleave
const headerHoverNavs = document.querySelectorAll("nav.hover-nav");
headerHoverNavs.forEach((headerHover) => {
  headerHover.addEventListener("mouseleave", (event) => {
    const detailsElements = event.currentTarget.querySelectorAll(
      "ul details.menu-level-1"
    );

    detailsElements.forEach((detailsElement, index) => {
      if (index != 0) {
        const summaryElement = detailsElement.querySelector("summary");
        detailsElement.removeAttribute("open");
        summaryElement.setAttribute("aria-expanded", "false");
      }
    });

    const firstElement = detailsElements[0];
    const isOpen = firstElement.hasAttribute("open");
    if (!isOpen) {
      firstElement.setAttribute("open", "");
      firstElement
        .querySelector("summary")
        .setAttribute("aria-expanded", "true");
    }

    moveUnderline(firstElement);
  });
});

// Open the correct menu item on mouse hover, close other menus and move underline to new position
document.querySelectorAll("details.hover-open").forEach((detailsElement) => {
  detailsElement.addEventListener("mouseenter", (event) => {
    const openDetailsElements = event.currentTarget
      .closest("ul")
      .querySelectorAll("details[open]");

    if (
      [...openDetailsElements].find((elem) => elem.className === "menu-opening")
    )
      return;

    openDetailsElements.forEach((openDetailsElement) => {
      if (openDetailsElement !== event.target.closest("details")) {
        const summaryElement = openDetailsElement.querySelector("summary");
        openDetailsElement.removeAttribute("open");
        summaryElement.setAttribute("aria-expanded", "false");
      }
    });

    const isOpen = detailsElement.hasAttribute("open");
    if (!isOpen) {
      detailsElement.setAttribute("open", "");
      detailsElement
        .querySelector("summary")
        .setAttribute("aria-expanded", "true");
    }
    moveUnderline(detailsElement);
  });

  detailsElement.addEventListener("mouseleave", (event) => {
    const openDetailsElements = event.currentTarget
      .closest("ul")
      .querySelectorAll("details[open]");

    if (
      [...openDetailsElements].find((elem) => elem.className === "menu-opening")
    )
      return;

    openDetailsElements.forEach((openDetailsElement) => {
      if (openDetailsElement !== event.currentTarget) {
        const summaryElement = openDetailsElement.querySelector("summary");
        openDetailsElement.removeAttribute("open");
        summaryElement.setAttribute("aria-expanded", "false");
      }
    });
  });
});

document
  .querySelectorAll("details.hover-open-submenu")
  .forEach((detailsElement) => {
    let showDelay = 300;
    let hideDelay = 400;
    let menuEnterTimer;
    let menuLeaveTimer;

    detailsElement.addEventListener("mouseenter", (event) => {
      const openDetailsElements = event.currentTarget
        .closest("ul")
        .querySelectorAll("details[open]");

      clearTimeout(menuLeaveTimer);

      openDetailsElements.forEach((openDetailsElement) => {
        if (openDetailsElement !== event.target.closest("details")) {
          const summaryElement = openDetailsElement.querySelector("summary");
          openDetailsElement.removeAttribute("open");
          summaryElement.setAttribute("aria-expanded", "false");
        }
      });

      const isOpen = detailsElement.hasAttribute("open");
      if (!isOpen) {
        menuEnterTimer = setTimeout(function () {
          detailsElement.setAttribute("open", "");
          detailsElement
            .querySelector("summary")
            .setAttribute("aria-expanded", "true");
        }, showDelay);
      }
    });

    detailsElement.addEventListener("mouseleave", (event) => {
      clearTimeout(menuEnterTimer);

      const openDetailsElements = event.currentTarget
        .closest("ul")
        .querySelectorAll("details[open]");
      menuLeaveTimer = setTimeout(function () {
        openDetailsElements.forEach((openDetailsElement) => {
          if (openDetailsElement !== event.currentTarget) {
            const summaryElement = openDetailsElement.querySelector("summary");
            openDetailsElement.removeAttribute("open");
            summaryElement.setAttribute("aria-expanded", "false");
          }
        });
      }, hideDelay);
    });
  });

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");

  if (!summary.hasAttribute("aria-expanded")) {
    summary.setAttribute("aria-expanded", "false");
  }

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    if (event.currentTarget.closest("ul")) {
      // Find all open menus on the same level and close them
      const openDetailsElements = event.currentTarget
        .closest("ul")
        .querySelectorAll("details[open]");
      const detailsElement = event.currentTarget.closest("details");
      const isOpen = detailsElement.hasAttribute("open");

      openDetailsElements.forEach((openDetailsElement) => {
        const summaryElement = openDetailsElement.querySelector("summary");
        openDetailsElement.removeAttribute("open");
        summaryElement.setAttribute("aria-expanded", "false");
      });
    }

    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (!container  || !elementToFocus)
    return;
  let elements = getFocusableElements(container);
  let first = elements[0];
  let last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.firstLevelMenus = this.querySelectorAll(
      "details.menu-level-1 > summary"
    );

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
    this.mobileMainMenu = document.querySelector("#MobileMainMenu");
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.firstLevelMenus.forEach((summary) =>
      summary.addEventListener("mouseenter", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;

    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }

    if (summaryElement.classList.contains("menu-drawer__menu-level-1")) {
      moveUnderline(detailsElement);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      // Open first submenu by default
      // this.mainDetailsToggle.querySelector('.menu-drawer__menu > li > details > summary').click();
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        //details.removeAttribute('open');
        //details.classList.remove('menu-opening');
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);
